import {
  ensureInitialized,
  fetchAndActivate,
  getRemoteConfig,
  isSupported,
  RemoteConfig,
} from 'firebase/remote-config';

import { initApp } from './init-app';
import { remoteAppConfigDefaults } from './remote-app-config-defaults';

let remoteConfig: RemoteConfig | undefined = undefined;

// Undefined where IndexedDB cannot be opened: the SDK opens it as soon as the instance exists and leaves the rejection unhandled.
export const getRemoteAppConfig = async () => {
  if (!remoteConfig) {
    if (!(await isSupported())) {
      return undefined;
    }

    remoteConfig = getRemoteConfig(initApp());

    remoteConfig.defaultConfig = remoteAppConfigDefaults;

    if (import.meta.env.VITE_ENVIRONMENT !== 'production') {
      remoteConfig.settings.minimumFetchIntervalMillis = 1;
    }

    // Offline, Firebase Installations rejects a promise it only handles after an IndexedDB round trip.
    await (navigator.onLine
      ? fetchAndActivate(remoteConfig)
      : ensureInitialized(remoteConfig));
  }

  return remoteConfig;
};

export const clearRemoteAppConfig = () => {
  remoteConfig = undefined;
};
